module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fullscreenLoading),
      expression: "fullscreenLoading"
    }],
    staticClass: " padding-left-30 padding-right-30 padding-bottom-30"
  }, [_c('div', {
    staticClass: "vctb-list"
  }, [_c('div', {
    staticClass: "vctb-item",
    class: {
      'vctb-item-active': _vm.vctbIndex == 0
    },
    on: {
      "click": function($event) {
        return _vm.tabChange(0)
      }
    }
  }, [_vm._v("\n      全部 (" + _vm._s(_vm.tender_count['all'] || 0) + ")\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "vctb-item",
    class: {
      'vctb-item-active': _vm.vctbIndex == 1
    },
    on: {
      "click": function($event) {
        return _vm.tabChange(1)
      }
    }
  }, [_vm._v("\n      招标 (" + _vm._s(_vm.tender_count['a1'] || 0) + ")\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "vctb-item",
    class: {
      'vctb-item-active': _vm.vctbIndex == 2
    },
    on: {
      "click": function($event) {
        return _vm.tabChange(2)
      }
    }
  }, [_vm._v("\n      中标 (" + _vm._s(_vm.tender_count['a2'] || 0) + ")\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "padding-left-10 padding-right-10 "
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "box5"
    }, [_c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(" " + _vm._s(item.pubtime ? _vm.dayjs(Number(item.pubtime) * 1000).format('YYYY-MM-DD') : "--") + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.comeFromArr || "其它网站（细类不明）"))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.title || '--'))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.owner || '--'))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2  justify-center  width-80  ",
      staticStyle: {
        "flex": "none"
      }
    }, [_c('span', {
      staticClass: "cpoint",
      staticStyle: {
        "color": "#0070c0"
      },
      on: {
        "click": function($event) {
          return _vm.clickShow(item)
        }
      }
    }, [_vm._v("详情")])])])
  }), _vm._v(" "), (!_vm.list.length) ? _c('div', {
    staticClass: "padding-bottom-40"
  }, [_c('nomore')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right ",
    staticStyle: {
      "padding": "10px 0"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.pagesize,
      "page-sizes": _vm.pageSizes,
      "hide-on-single-page": false,
      "layout": "prev, pager, next,sizes",
      "current-page": _vm.currentPage,
      "total": _vm.totalnum
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": function($event) {
        return _vm.handleCurrentChange($event)
      }
    }
  })], 1)], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.showData.type,
      "visible": _vm.showDetail
    },
    on: {
      "update:visible": function($event) {
        _vm.showDetail = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "height": "70vh",
      "overflow-y": "scroll"
    }
  }, [_c('table', {
    staticClass: "pure-table pure-table-bordered"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "30%",
      "background": "#F7F7F7"
    }
  }, [_vm._v("招标公告标题")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.showData.title || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("发布渠道")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.showData.comeFromArr || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("项目名称")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.showData.projectName || '--'))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("公告类型(细类)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.showData.projectName || '--'))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("项目更新时间")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.showData.update_time ? _vm.dayjs(Number(_vm.showData.update_time) * 1000).format('YYYY-MM-DD') : "--") + "\n          ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("项目编号")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.showData.projectNum || '--'))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("项目发布时间")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.showData.blockTime || '--'))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("项目截止时间")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.showData.blockTime || '--'))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("采购单位")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.showData.owner || '--'))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("采购单位地址")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.showData.ownerAddress || '--'))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("采购联系人")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.showData.ownerPerson || '--'))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("采购联系方式")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.showData.ownerPhone || '--'))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("项目所属地")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.showData.region || '--'))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("代理机构")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.showData.agency || '--'))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("代理机构地址")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.showData.agencyAddress || '--'))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("代理机构联系方式")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.showData.agencyPersor || '--'))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("项目预算金额")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.showData.budget || '--'))])]), _vm._v(" "), (_vm.showData.type == '中标公告') ? [_c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("中标成交金额")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.showData.bidPrice || '--'))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("中标单位")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.showData.bidUnit || '--'))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("中标单位地址")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.showData.bidUnit || '--'))])])] : _vm._e()], 2)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box5 box2_cc"
  }, [_c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("发布日期")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("发布渠道")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("公告标题")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("采购单位")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold width-80 justify-center",
    staticStyle: {
      "flex": "none"
    }
  }, [_vm._v("操作")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-101f0d60"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/company/components/tender-page.vue
// module id = 879
// module chunks = 1